// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3F0gW","title":"InfoRow_title__MWLJC"};